import React, { FunctionComponent, useState } from 'react';
import errorHandler from '../../../../../common/service/errorHandler';
import { IButtonClickAction } from '../../../presentational/actionButtons/ActionButtons';
import Submit from '../../../presentational/actionButtons/customiseSubmit/Submit';
import IActionButtonProps from '../IActionButtonProps';

const ProceedToBasketButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const onClick: IButtonClickAction = () => {
    setIsSubmitting(true);

    if (config.basketUrl) {
      (window as any).location = config.basketUrl;
    } else {
      errorHandler.handleError(new Error(`Missing basket url.`));
    }
  };

  return <Submit onClick={onClick} disabled={isSubmitting || config.disabled} />;
};

export default ProceedToBasketButtonContainer;
